import React from "react";
import Navbar from "../Navbar/Navbar";
import Bola from "../Bola";
import Footer from "../Footer/Footer";
import { Link, NavLink, useParams } from "react-router-dom";
import "./Boshlangich.css";
import Search from "../Search";


import play from "../assets/Play.svg";
import BoshlangichPagination from "./BoshlangichPagination";
import axios from "axios";
import { baseURL } from "../Config/Config";
import { Rtr } from "../context/context";


export default function BoshlangichTalim() {

  const [category, setCotegory] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [current_page, setCurrent_page] = React.useState();
  const [total_pages, setTotal_pages] = React.useState();

  const [data_api, set_data_api] = React.useState()
  // eslint-disable-next-line
  const [data_context, setData] = React.useContext(Rtr)
  let { id } = useParams();

  const [ , , search,] = React.useContext(Rtr);



  React.useEffect(() => {
    axios
      .get(
        `${baseURL}rtr_base_app/subject-list/${id}/level/?general_subject=${category}&page=${page}&search=${search}`
      )
      .then((response) => {
        set_data_api(response.data.results);
        setCurrent_page(response.data.current_page);
        setTotal_pages(response.data.total_pages);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id, page, category,search]);
  if (!data_context) return null;
  if (!data_api) return null;
  const hadleFilter = (id) => {
    setCotegory(id)
  }
  if (id == 1) {
    return (
      <div>
        <Navbar />
        <Bola />

        <div className="container video_name">
          <h1 className="daraja_name">
            Boshlang‘ich kasbiy ta’lim
          </h1>
        </div>
        <div className="container">
          <div className="video-materials">
            <div className="video-top">
              <div className="left">
                <Link to="/" className="bosh">
                  Bosh sahifa
                </Link>
                <Link className="left-material">
                  Boshlang‘ich kasbiy ta’lim
                </Link>
              </div>
              <div className="right">
                <Search />
              </div>
            </div>
          </div>
          <div className="boshlangich">
            <div className="boshlangich-left">
              <div className="boshlangich-left-top">
                {/* <p>Boshlang‘ich professional ta’lim</p> */}
              </div>
              <div className="boshlangich-left-box">
                <div className="boshlangich-fan">
                  <NavLink onClick={(e) => hadleFilter('')}><b>Barchasi</b></NavLink>
                </div>
                {data_context[id - 1].general_subjects.map((element) => {
                  return (

                    <div className="boshlangich-fan" key={element['id']}>
                      <NavLink onClick={(e) => hadleFilter(element['id'])}>{element['title']}</NavLink>
                    </div>
                  )
                })}



              </div>
            </div>
            <div className="boshlangich-right">

              <div className="boshlangich-right-box">
                {data_api.map((item) => {
                  return (
                    <Link to={`/boshlangich-talim/${id}/${item.id}`} className="boshlangich-card" key={item.id}>
                      <div className="boshlangich-img">
                        <img src={item.photo} alt="" />
                      </div>
                      <div className="boshlangich-card-box">
                        <a className="boshlangich-title">
                          {item.title}
                        </a>
                        <a className="title-code">{item.code}</a>

                        <div className="boshlangich-card-bottom">
                          <span>
                            <img src={play} alt="rasm" />
                            {item.themes_count}
                          </span>
                          <span>
                            <svg
                              width="22"
                              height="16"
                              viewBox="0 0 22 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.257 6.962C20.731 7.582 20.731 8.419 20.257 9.038C18.764 10.987 15.182 15 11 15C6.81801 15 3.23601 10.987 1.74301 9.038C1.51239 8.74113 1.38721 8.37592 1.38721 8C1.38721 7.62408 1.51239 7.25887 1.74301 6.962C3.23601 5.013 6.81801 1 11 1C15.182 1 18.764 5.013 20.257 6.962V6.962Z"
                                stroke="#4ECB71"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z"
                                stroke="#4ECB71"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            {item.view_count}
                          </span>
                        </div>
                      </div>
                    </Link>
                  )
                })}


              </div>
              <BoshlangichPagination
                setPage={setPage}
                current_page={current_page}
                total_pages={total_pages}
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
  if (id == 2) {
    return (
      <div>
        <Navbar />
        <Bola />

        <div className="container video_name">
          <h1 className="daraja_name">
            O'rta kasbiy ta’lim
          </h1>
        </div>
        <div className="container">
          <div className="video-materials">
            <div className="video-top">
              <div className="left">
                <Link to="/" className="bosh">
                  Bosh sahifa
                </Link>
                <Link className="left-material">
                  O'rta kasbiy ta'lim
                </Link>
              </div>
              <div className="right">
                <Search />
              </div>
            </div>
          </div>
          <div className="boshlangich">
            <div className="boshlangich-left">
              <div className="boshlangich-left-top">
                {/* <p>Boshlang‘ich professional ta’lim</p> */}
              </div>
              <div className="boshlangich-left-box">
                <div className="boshlangich-fan">
                  <NavLink onClick={(e) => hadleFilter('')}><b>Barchasi</b></NavLink>
                </div>
                {data_context[id - 1].general_subjects.map((element) => {
                  return (

                    <div className="boshlangich-fan" key={element['id']}>
                      <NavLink onClick={(e) => hadleFilter(element['id'])}>{element['title']}</NavLink>
                    </div>
                  )
                })}



              </div>
            </div>
            <div className="boshlangich-right">

              <div className="boshlangich-right-box">
                {data_api.map((item) => {
                  return (
                    <Link to={`/boshlangich-talim/${id}/${item.id}`} className="boshlangich-card" key={item.id}>
                      <div className="boshlangich-img">
                        <img src={item.photo} alt="" />
                      </div>
                      <div className="boshlangich-card-box">
                        <a className="boshlangich-title">
                          {item.title}
                        </a>
                        <a className="boshlangich-title">{item.code}</a>
                        <div className="boshlangich-card-bottom">
                          <span>
                            <img src={play} alt="rasm" />
                            {item.themes_count}
                          </span>
                          <span>
                            <svg
                              width="22"
                              height="16"
                              viewBox="0 0 22 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.257 6.962C20.731 7.582 20.731 8.419 20.257 9.038C18.764 10.987 15.182 15 11 15C6.81801 15 3.23601 10.987 1.74301 9.038C1.51239 8.74113 1.38721 8.37592 1.38721 8C1.38721 7.62408 1.51239 7.25887 1.74301 6.962C3.23601 5.013 6.81801 1 11 1C15.182 1 18.764 5.013 20.257 6.962V6.962Z"
                                stroke="#4ECB71"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z"
                                stroke="#4ECB71"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            {item.view_count}
                          </span>
                        </div>
                      </div>
                    </Link>
                  )
                })}


              </div>
              <BoshlangichPagination
                setPage={setPage}
                current_page={current_page}
                total_pages={total_pages}
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
  if (id == 3) {
    return (
      <div>
        <Navbar />
        <Bola />

        <div className="container video_name">
          <h1 className="daraja_name">
            O'rta-maxsus kasbiy ta'lim
          </h1>
        </div>
        <div className="container">
          <div className="video-materials">
            <div className="video-top">
              <div className="left">
                <Link to="/" className="bosh">
                  Bosh sahifa
                </Link>
                <Link className="left-material">
                  O'rta-maxsus kasbiy ta'lim
                </Link>
              </div>
              <div className="right">
                <Search />
              </div>
            </div>
          </div>
          <div className="boshlangich">
            <div className="boshlangich-left">
              <div className="boshlangich-left-top">
                {/* <p>Boshlang‘ich professional ta’lim</p> */}
              </div>
              <div className="boshlangich-left-box">
                <div className="boshlangich-fan">
                  <NavLink onClick={(e) => hadleFilter('')}><b>Barchasi</b></NavLink>
                </div>
                {data_context[id - 1].general_subjects.map((element) => {
                  return (

                    <div className="boshlangich-fan" key={element['id']}>
                      <NavLink onClick={(e) => hadleFilter(element['id'])}>{element['title']}</NavLink>
                    </div>
                  )
                })}



              </div>
            </div>
            <div className="boshlangich-right">

              <div className="boshlangich-right-box">
                {data_api.map((item) => {
                  return (
                    <Link to={`/boshlangich-talim/${id}/${item.id}`} className="boshlangich-card" key={item.id}>
                      <div className="boshlangich-img">
                        <img src={item.photo} alt="" />
                      </div>
                      <div className="boshlangich-card-box">
                        <a className="boshlangich-title">
                          {item.title}
                        </a>
                        <a className="boshlangich-title">{item.code}</a>

                        <div className="boshlangich-card-bottom">
                          <span>
                            <img src={play} alt="rasm" />
                            {item.themes_count}
                          </span>
                          <span>
                            <svg
                              width="22"
                              height="16"
                              viewBox="0 0 22 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.257 6.962C20.731 7.582 20.731 8.419 20.257 9.038C18.764 10.987 15.182 15 11 15C6.81801 15 3.23601 10.987 1.74301 9.038C1.51239 8.74113 1.38721 8.37592 1.38721 8C1.38721 7.62408 1.51239 7.25887 1.74301 6.962C3.23601 5.013 6.81801 1 11 1C15.182 1 18.764 5.013 20.257 6.962V6.962Z"
                                stroke="#4ECB71"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z"
                                stroke="#4ECB71"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            {item.view_count}
                          </span>
                        </div>
                      </div>
                    </Link>
                  )
                })}


              </div>
              <BoshlangichPagination
                setPage={setPage}
                current_page={current_page}
                total_pages={total_pages}
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

}
